"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClipboardButtonTooltip = exports.ClipboardButton = void 0;
var clipboard_button_1 = require("./clipboard-button");
Object.defineProperty(exports, "ClipboardButton", { enumerable: true, get: function () { return clipboard_button_1.ClipboardButton; } });
var clipboard_button_tooltip_1 = require("./clipboard-button-tooltip");
Object.defineProperty(exports, "ClipboardButtonTooltip", { enumerable: true, get: function () { return clipboard_button_tooltip_1.ClipboardButtonTooltip; } });
